import { Component, Input } from '@angular/core';
import { AppState } from 'src/app/app.types';
import { Store } from '@ngrx/store';
import { DynamicCourseStyleService } from 'src/app/styles/dynamic-course-style.service';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { TruncatePipe } from 'src/app/widget/truncate.pipe';
import { TranslateModule } from '@ngx-translate/core';
import {
  HelpVideoDialogComponent,
  HelpVideoDialogData,
} from '../help-video-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UIEventEnum } from 'src/app/utility/amplitude-tracking/tracking.types';
import { TrackingService } from 'src/app/utility/amplitude-tracking/tracking.service';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { StepsProgressButtonComponent } from '../steps-progress-button/steps-progress-button.component';
import { TourTrackType } from '../../pages/onboarding/guided-tour';

export interface Breadcrumb {
  text: string;
  icon?: string;
  route?: string;
}

export interface HelpCrumb {
  id: string;
  link?: string;
  text?: string;
  icon?: string;
}

export interface Action {
  id: string;
  label: string;
  icon?: string;
  link?: string;
}

export interface NavigationBreadcrumb {
  homeUrl: string;
  currentPage: string;
  breadcrumbs: Breadcrumb[];
  back?: {
    handleBack: () => void;
  };
  help?: HelpCrumb[];
  allowFullScreen?: boolean;
  actions?: Action[];
  progressStepType?: TourTrackType;
}

@Component({
  selector: 'qa-navigation-breadcrumbs',
  templateUrl: './navigation-breadcrumbs.component.html',
  styleUrls: ['./navigation-breadcrumbs.component.scss'],
  imports: [
    MatIcon,
    TruncatePipe,
    TranslateModule,
    ButtonComponent,
    StepsProgressButtonComponent,
  ],
})
export class NavigationBreadcrumbsComponent {
  @Input() navigationBreadcrumb: NavigationBreadcrumb;
  state: AppState;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private dynamicStyle: DynamicCourseStyleService,
    private matDialog: MatDialog,
    private trackingService: TrackingService
  ) {
    this.store.subscribe((state) => {
      this.state = state;
    });
  }

  redirect(route: string) {
    if (route) {
      this.router.navigateByUrl(route);
    }
  }

  logoUrl(): string | null {
    if (this.dynamicStyle.isCms) {
      return null;
    }
    return (
      this.state?.course?.course?.logo_url ||
      this.state?.liveEvent?.logo_url ||
      this.state?.exam?.exam?.logo_url ||
      null
    );
  }

  onActionClick(action: Action) {
    if (action?.link) {
      this.openLink(action);
    } else {
      this.openVideo(action.id);
    }
  }

  openVideo(videoName = 'teaser') {
    this.trackingService.trackEvent({
      event_type: UIEventEnum.VIDEO_OPENED,
      event_properties: {
        type: videoName,
      },
    });
    this.matDialog.open<HelpVideoDialogComponent, HelpVideoDialogData>(
      HelpVideoDialogComponent,
      {
        data: {
          videoName,
        },
      }
    );
  }

  openLink(action: Action) {
    this.trackingService.trackEvent({
      event_type: UIEventEnum.ACADEMY_OPENED,
      event_properties: {
        type: action.id,
      },
    });
    window.open(action.link);
  }
}
